module.exports = __webpack_public_path__ + "img/bj45.aed809c6.png";